<template>
  <ul class="list-group">
    <slot />
  </ul>
</template>
<script>
import { ContainerMixin } from 'vue-slicksort';

export default {
  mixins: [ContainerMixin],
  data() {
    return {
      list: [1, 2, 3, 4, 5, 6, 7],
    };
  },

};
</script>
<style>

</style>
